import Vue from 'vue';
import Router from 'vue-router';

// 2、注册
Vue.use(Router)
// 3、实例化
export default new Router({
  routes: [
    // {
    //   path: '/keyword',
    //   name: 'keyword',
    //   component: () => import('@/components/keyword')

    // },
    // {
    //   path: '/',
    //   name: 'index',
    //   component: () => import('@/views/index'),
    //   meta: {
    //     keepAlive: true
    //   }
    // },
    // {
    //   path: '/stationDetail',
    //   name: 'stationDetail',
    //   component: () => import('@/views/stationDetail')

    // },
    // {
    //   path: '/gasoline',
    //   name: 'gasoline',
    //   component: () => import('@/views/gasoline')

    // },
    // {
    //   path: '/order',
    //   name: 'order',
    //   component: () => import('@/views/order')

    // },
    // {
    //   path: '/orderDetail',
    //   name: 'orderDetail',
    //   component: () => import('@/views/orderDetail')

    // },
    // {
    //   path: '/auditQr',
    //   name: 'auditQr',
    //   component: () => import('@/views/auditQr')

    // },
    // {
    //   path: '/me',
    //   name: 'me',
    //   component: () => import('@/views/me'),
    //   meta: {
    //     keepAlive: true
    //   }

    // }, {
    //   path: '/userAudit',
    //   name: 'userAudit',
    //   component: () => import('@/views/userAudit')

    // }, {
    //   path: '/identityProve',
    //   name: 'identityProve',
    //   component: () => import('@/views/identityProve')

    // }, {
    //   path: '/couponManage',
    //   name: 'couponManage',
    //   component: () => import('@/views/couponManage')
    // }, {
    //   path: '/invoiceHistory',
    //   name: 'invoiceHistory',
    //   component: () => import('@/views/invoiceHistory')
    // }, {
    //   path: '/invoice',
    //   name: 'invoice',
    //   component: () => import('@/views/invoice')
    // }, {
    //   path: '/invoiceDetail',
    //   name: 'invoiceDetail',
    //   component: () => import('@/views/invoiceDetail')
    // }, {
    //   path: '/invoiceDetailOrder',
    //   name: 'invoiceDetailOrder',
    //   component: () => import('@/views/invoiceDetailOrder')
    // }, {
    //   path: '/invoiceOpen',
    //   name: 'invoiceOpen',
    //   component: () => import('@/views/invoiceOpen')
    // }, {
    //   path: '/share',
    //   name: 'share',
    //   component: () => import('@/views/share')
    // }, {
    //   path: '/profile',
    //   name: 'profile',
    //   component: () => import('@/views/profile')
    // }, {
    //   path: '/serviceAgreement',
    //   name: 'serviceAgreement',
    //   component: () => import('@/views/serviceAgreement')
    // },
    // {
    //   path: '/privacyAgreement',
    //   name: 'privacyAgreement',
    //   component: () => import('@/views/privacyAgreement')
    // },
    // {
    //   path: '/disclaimer',
    //   name: 'disclaimer',
    //   component: () => import('@/views/disclaimer')
    // },
    // {
    //   path: '/loginOpt',
    //   name: 'loginOpt',
    //   component: () => import('@/views/loginOpt')
    // },
    // {
    //   path: '/couponDetail',
    //   name: 'couponDetail',
    //   component: () => import('@/views/couponDetail')
    // }, {
    //   path: '/couponCheck',
    //   name: 'couponCheck',
    //   component: () => import('@/views/couponCheck')
    // }, {
    //   path: '/paymentInvite',
    //   name: 'paymentInvite',
    //   component: () => import('@/views/paymentInvite')
    // }, 
    {
      path: '/aditem/:id',
      name: 'aditem',
      component: () => import('@/views/aditem'),
      meta: {
        title: '推广链接'
      }
    },
    {
      path: '/ad/:code',
      name: 'ad',
      component: () => import('@/views/ad'),
      meta: {
        title: '推广链接'
      }
    },
    {
      path: '/msactive',
      name: 'msactive',
      component: () => import('@/views/msactive'),
      meta: {
        title: '活动'
      }
    },
    {
      path: '/receiveCoupon',
      name: 'receiveCoupon',
      component: () => import('@/views/receiveCoupon'),
      meta: {
        title: '活动'
      }
    },
    {
      path: '/guideList',
      name: 'guideList',
      component: () => import('@/views/manualBook/GuideList'),
      meta: {
        title: '使用手册'
      }
    },
    {
      path: '/guideDetail',
      name: 'guideDetail',
      component: () => import('@/views/manualBook/GuideDetail'),
      meta: {
        title: '详情'
      }

    },
    {
      path: '/memberAppGuideList',
      name: 'memberAppGuideList',
      component: () => import('@/views/manualBook/GuideList'),
      meta: {
        title: '使用手册'
      }
    },
    {
      path: '/appProfile',
      name: 'appProfile',
      component: () => import('@/views/agreement/profile'),
      meta: {
        title: '相关协议'
      }
    }, {
      path: '/appServiceAgreement',
      name: 'appServiceAgreement',
      component: () => import('@/views/agreement/serviceAgreement'),
      meta: {
        title: '服务条款'
      }
    },
    {
      path: '/appPrivacyAgreement',
      name: 'appPrivacyAgreement',
      component: () => import('@/views/agreement/privacyAgreement'),
      meta: {
        title: '隐私协议'
      }
    },
    {
      path: '/appDisclaimer',
      name: 'appDisclaimer',
      component: () => import('@/views/agreement/disclaimer'),
      meta: {
        title: '免责声明'
      }
    },
    {
      path: '/appInvoiceAgreement',
      name: 'appinvoiceAgreement',
      component: () => import('@/views/agreement/invoiceAgreement'),
      meta: {
        title: '发票开具规则'
      }
    },
    {
      path: '/appCancellation',
      name: 'appCancellation',
      component: () => import('@/views/agreement/cancellation'),
      meta: {
        title: '账户注销'
      }
    },
    , {
      path: '/bannerDetail',
      name: 'bannerDetail',
      component: () => import('@/views/bannerDetail'),
      meta: {
        title: '详细'
      }
    }
    , {
      path: '/activeDetail',
      name: 'activeDetail',
      component: () => import('@/views/activeDetail'),
      meta: {
        title: '活动详细'
      }
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js